<!-- begin::Quick Nav -->
<!-- <ul class="m-nav-sticky" style="margin-top: 30px;" appunwraptag="">

	<li class="m-nav-sticky__item" data-toggle="m-tooltip" title="Purchase" data-placement="left">
		<a href="https://themeforest.net/item/metronic-responsive-admin-dashboard-template/4021469?ref=keenthemes" >
			<i class="la la-cart-arrow-down"></i>
		</a>
	</li>
	<li class="m-nav-sticky__item" data-toggle="m-tooltip" title="Documentation" data-placement="left">
		<a href="https://keenthemes.com/metronic/documentation.html" >
			<i class="la la-code-fork"></i>
		</a>
	</li>
	<li class="m-nav-sticky__item" data-toggle="m-tooltip" title="Support" data-placement="left">
		<a href="https://keenthemes.com/forums/forum/support/metronic5/" >
			<i class="la la-life-ring"></i>
		</a>
	</li>
</ul> -->
<!-- begin::Quick Nav -->


// WEBPACK FOOTER //
// ./src/app/core/layouts/tooltips/tooltips.component.html